<mat-toolbar>
    <mat-toolbar-row>
        <div class="logo">
            <a class="secondary-button" (click)="layoutService.toggle()">
                <span><mat-icon fontIcon="menu">menu</mat-icon></span>
            </a>
            <a href="/home" title="Inicio">
                <img src="img/small-logo.png" alt="Asoc. Cabildos" />
            </a>
        </div>
        <mat-chip-listbox>
            <a title="Inicio"><mat-icon matBadgeColor="">home</mat-icon></a>
        </mat-chip-listbox>
        <mat-chip-listbox aria-label="staff groups" style="float: left">
            <mat-chip disabled>{{ shortenRoute }}</mat-chip>
        </mat-chip-listbox>

        <div class="toolbar-center">
            <span>{{ appTitle }}</span>
        </div>

        <div class="toolbar-right">
            <mat-chip-listbox class="role-chips">
                <button
                    class="primary-button"
                    *ngFor="let group of profile?.role_group"
                    selected
                >
                    {{ group.name }}
                </button>
                <button
                    *ngIf="profile?.is_staff"
                    selected
                    class="primary-button"
                >
                    staff
                </button>
                <button
                    *ngIf="profile?.is_superuser"
                    class="primary-button"
                    selected
                >
                    superuser
                </button>
                <button class="secondary-button">
                    {{ profile?.first_name }} {{ profile?.last_name }}
                </button>
            </mat-chip-listbox>

            <a
                mat-icon-button
                aria-label="cerrar sesión"
                title="cerrar sesión"
                (click)="onLogout()"
            >
                <mat-icon>power_settings_new</mat-icon>
            </a>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
